<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 d-none d-md-inline-block">
          <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="form_laive">
        <div class="box_loader">
          <div class="loader"></div>
        </div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template v-slot:header>
            <div class="row">
              <div class="col-12 col-md-6">
                <h3 class="mb-0">Carga de Productos Foco</h3>
              </div>
            </div>
          </template>
          <div>
            <div class="px-3 pb-3">
              <form @submit.prevent="submitExcel" class="row">
                <div class="col-md-4 mb-3">
                    <label class="col-form-label form-control-label">Archivo:</label>
                    <file-input @change="inputFile" required accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"></file-input>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="col-form-label form-control-label">Fecha de Inicio:</label>
                    <base-input addon-left-icon="ni ni-calendar-grid-58" name="inicio">
                      <flat-picker :config="configDate" class="form-control datepicker" required v-model="dataSend.inicio"></flat-picker>
                    </base-input>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="col-form-label form-control-label">Fecha Fin:</label>
                    <base-input addon-left-icon="ni ni-calendar-grid-58" name="fin">
                      <flat-picker :config="configDate" class="form-control datepicker" required v-model="dataSend.fin"></flat-picker>
                    </base-input>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="notes_editor">
                    <p><strong>Consideraciones del Archivo</strong></p>
                    <ul>
                      <li>El archivo debe ser un Excel simple sin formato</li>
                    </ul>
                  </div>
                  <base-button type="primary" native-type="submit" class="btn-default my-0">Subir Productos Foco</base-button>
                </div>
              </form>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BasePagination from "@/components/BasePagination";
import {mapGetters} from 'vuex';
import FileInput from "@/components/Inputs/FileInput";
import swal from "sweetalert2";
import { useToast } from "vue-toastification";
import Notification from "@/components/Notification";
import DashboardNavbar from "../Layout/DashboardNavbar";
import flatPicker from "vue-flatpickr-component";
import {Spanish} from 'flatpickr/dist/l10n/es.js';
import "flatpickr/dist/flatpickr.css";
export default {
  components: {
    DashboardNavbar,
    BasePagination,
    RouteBreadCrumb,
    FileInput,
    flatPicker,
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
  },
  methods:{
    submitExcel() {
      const $this = this;
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
        }
      };
      const urlUploadExcel = process.env.VUE_APP_API_URL+`/producto/carga-producto-foco`
      var formData = new FormData();
      var excelfile = document.querySelector('#customFileLang');
      formData.append("file", excelfile.files[0])
      formData.append("inicio", this.dataSend.inicio)
      formData.append("fin", this.dataSend.fin)
      console.log(formData);
      axios.post(urlUploadExcel, formData, config)
      .then(function (response){
        console.log(response.status)
        const text = (response.data.status == 200) ? "Se Cargo el archivo" : response.data.message
        const icon = "ni ni-bell-55";
        const content = {
          component: Notification,
          props: {
            icon: icon,
            text: text,
            type: (response.data.status == 200) ? "success" : "danger",
          },
        };
        const toast = useToast();
        toast(content, {
          hideProgressBar: true,
          icon: false,
          closeButton: false,
          position: "top-right",
        });
        excelfile.value = ""
        document.querySelector(".custom-file-label").innerText = "Seleccionar Archivo"
        setTimeout(() => {
          //$this.$router.replace({name: 'Productos Foco'})
        }, 2000);
      })
      .catch(function (error) {
        const text = "Hubo un error en el archivo"
        const icon = "ni ni-bell-55";
        const content = {
          component: Notification,
          props: {
            icon: icon,
            text: text,
            type:"danger",
          },
        };
        const toast = useToast();
        toast(content, {
          hideProgressBar: true,
          icon: false,
          closeButton: false,
          position: "top-right",
        });
      })
    },
    inputFile(){
      var formData = new FormData();
      var excelfile = document.querySelector('#customFileLang');
      formData.append("file", excelfile.files[0])
      this.dataSend.file = formData;
      //console.log(formData)
    }
  },
  mounted() {
    if(this.user.rol == 3){
      this.distribuidoraIdCurrent = this.user.idDistribuidora
    }
    if(this.user.rol == 4){
      this.supervisorIdCurrent = this.user.codigo
      this.supervisorNameCurrent = this.user.nombre
      this.distribuidoraIdCurrent = this.user.idDistribuidora
    }
  },
  data() {
    return {
      files: [],
      configDate: {
        altInput: true,
        allowInput: true,
        locale: Spanish, // locale for this instance only
      },
      dataSend:{
        file: "",
        inicio : "",
        fin : ""
      }
    };
  },
};
</script>
<style lang="scss">
  .swal-wide{
    .swal2-popup{
      width: 52.5em;
    }
  }
  .page-item .page-link .fa{
    z-index: 0;
  }
  .notes_editor{
    font-size: 14px;
    p{
      margin: 0;
    }
  }
</style>
